// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DynamicSearchInputs_wrapper__lg7a9","item":"DynamicSearchInputs_item__32Qtu"};